<script setup>
import { UseImage } from '@vueuse/components'
import { useAttrs, computed } from 'vue'

// Disable automatic inheritance of non-prop attributes, so we can manually control which attributes are forwarded. This helps avoid an extra wrapping element, allowing us to target the UseImage component's rendered element directly with Tailwind selectors.
defineOptions({
  inheritAttrs: false
})

const attrs = useAttrs()

defineProps({
  src: {
    type: String,
    default: ''
  },
  loadingClass: {
    type: String,
    default: ''
  },
  alt: {
    type: String,
    default: ''
  }
})

// Create a computed property to filter and forward only desired attributes.
// This avoids passing an empty style attribute, which causes Vue to warn
// when the underlying UseImage component renders a fragment or multiple roots.
const filteredAttrs = computed(() => {
  const result = {}
  // Forward the class attribute if it's provided.
  if (attrs.class) result.class = attrs.class
  // Only forward the style attribute if it is non-empty.
  if (attrs.style && attrs.style.trim() !== '') result.style = attrs.style
  return result
})
</script>

<template>
  <UseImage :src="src" v-bind="filteredAttrs" :alt="alt">
    <template #loading>
      <LoadingOverlay :class="loadingClass" />
    </template>
    <template #error>
      <slot name="fallback" />
    </template>
  </UseImage>
</template>
